export default __webpack_public_path__ + "static/media/copy_q.17cb49ac.svg";